import {GetAsync, observer_mgl} from "mobx-graphlink";
import {Button, CheckBox, Column, Row, Spinner, Text, TextArea, TextInput} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {Observer, RunInAction_Set, useForceUpdate, UseWindowEventListener} from "web-vcore";
import React from "react";
import {ShowMessageBox} from "react-vmessagebox";
import {ScrollView} from "react-vscrollview";
import {StoryExploreComp} from "../../../../Engine/LiveSession/Components/StoryExploreComp.js";
import {GetStoryMessages} from "../../../../Server/DB/storyMessages.js";
import {MeID} from "../../../../Server/DB/users.js";
import {store} from "../../../../Store/index.js";
import {GetDefaultLLMPresets, LLMPreset} from "../../../../Store/main/tools/journey.js";
import {InAndroid} from "../../../../Utils/Bridge/Bridge_Native.js";
import {JSessionUI_Full} from "../JSessionUI.js";
import {GetLiveLocalSession_Reactive} from "../../../../Engine/LiveSessionManagement.js";
import {StoryMessage} from "../../../../Server/DB/storyMessages/@StoryMessage.js";
import {Story} from "../../../../Server/DB/stories.js";
import {Assert} from "js-vextensions";

export const LLMPanel_Header = observer_mgl(()=>{
	const uiState = store.main.engine.journey.llm;
	return (
		<>
			<Button p="0 5px" text="40%" onClick={()=>RunInAction_Set(()=>uiState.panelHeight = 40)}/>
			<Button p="0 5px" text="60%" onClick={()=>RunInAction_Set(()=>uiState.panelHeight = 60)}/>
			<Button p="0 5px" text="80%" onClick={()=>RunInAction_Set(()=>uiState.panelHeight = 80)}/>
			<Button p="0 5px" text="100%" onClick={()=>RunInAction_Set(()=>uiState.panelHeight = 100)}/>
			{/*<Text ml={5}>Recordings: (n/a atm)</Text>*/}
		</>
	);
});

export const LLMPanel = observer_mgl(()=>{
	const uiState = store.main.engine.journey.llm;
	const liveLocalSession = GetLiveLocalSession_Reactive();
	const storyComp = liveLocalSession?.Comp(StoryExploreComp);
	const story = storyComp?.story;
	const storyMessages = story ? GetStoryMessages(story.creator, story.id) : [];

	const fullMode = JSessionUI_Full();
	if (fullMode) {
		return (
			<Row style={{flex: 1, minHeight: 0}}>
				<LLMPanel_Side {...{storyComp, story, storyMessages}}/>
				<LLMPanel_Main {...{storyComp, story, storyMessages}}/>
			</Row>
		);
	}

	return <LLMPanel_Main {...{storyComp, story, storyMessages}}/>;
});
type SharedProps = {storyComp: StoryExploreComp|n, story: Story|n, storyMessages: StoryMessage[]};

export const LLMPanel_Side = observer_mgl((props: SharedProps)=>{
	const {storyComp, story, storyMessages} = props;
	const [msgOffset, setMsgOffset] = React.useState(0);
	const targetMessageProto = storyComp?.GetCurrentMessage(msgOffset);
	const forceUpdate = useForceUpdate();

	return (
		<Column style={{flex: 2}}>
			<Row>
				<Button mdIcon="refresh" onClick={()=>forceUpdate()}/>
				<Button ml={5} text="Thinking" enabled={targetMessageProto?.thinkingContent != null} onClick={()=>{
					ShowMessageBox({
						title: "Thinking content",
						message: ()=><ScrollView style={{maxHeight: 500}}><Text sel style={{whiteSpace: "pre-wrap"}}>{targetMessageProto?.thinkingContent ?? "<none>"}</Text></ScrollView>,
					});
				}}/>
				<Text ml={5}>Msg:</Text>
				<Spinner ml={5} min={Number.MIN_SAFE_INTEGER} instant value={msgOffset} onChange={val=>setMsgOffset(val)}/>
				{[0, -1, -2, -3, -4, -5, -6, -7, -8, -9, -10].map(n=>(
					<Button key={n} p="5px 10px" text={`${n}`}
						style={msgOffset === n ? {fontWeight: "bold", backgroundColor: "rgba(255,255,255,.3)"} : undefined}
						onClick={()=>setMsgOffset(n)}/>
				))}
				<Row ml="auto">
					{targetMessageProto?.outputTokens != null && <Text mr={5}>{targetMessageProto.outputTokens} tokens</Text>}
					<Button mdIcon="keyboard-return" title="Reset story to this step" enabled={msgOffset != 0 && targetMessageProto != null} onClick={async()=>{
						await storyComp?.LoadStoryForChain(storyComp.story!, storyMessages, storyMessages.find(a=>a.id == targetMessageProto!.uploadedId)!);
						setMsgOffset(0);
					}}/>
				</Row>
			</Row>
			<ScrollView style={{padding: `10px 0`}}>
				<Text sel style={{whiteSpace: "pre-wrap"}}>{targetMessageProto?.content ?? "<n/a>"}</Text>
			</ScrollView>
		</Column>
	);
});


export const LLMPanel_Main = observer_mgl((props: SharedProps)=>{
	const {storyComp, story, storyMessages} = props;
	const uiState = store.main.engine.journey.llm;
	const forceUpdate = useForceUpdate();

	const showResponseX = (stepsBack: number)=>{
		if (storyComp == null) return;
		ShowMessageBox({
			title: `LLM message <latest> - ${stepsBack}`,
			message: ()=>{
				const targetMessageProto = storyComp.GetCurrentMessage(-stepsBack);
				if (targetMessageProto == null) return null;
				// todo: maybe merge this with the "Message details" dialog in StoryMessageUI.tsx
				return (
					<ScrollView style={{padding: `10px 0`, width: window.innerWidth - 50, height: window.innerHeight - 100}}>
						<Text sel style={{whiteSpace: "pre-wrap"}}>{targetMessageProto.content}</Text>
						<Row>
							<Button text="Reset story to this step" onClick={async()=>{
								const targetUploadedMessage = storyMessages.find(a=>a.id == targetMessageProto.uploadedId);
								await storyComp.LoadStoryForChain(storyComp.story!, storyMessages, targetUploadedMessage!);
							}}/>
						</Row>
					</ScrollView>
				);
			},
		});
	};

	return (
		<Column style={{flex: 1}}>
			<Row>
				<Text>Msg:</Text>
				<Button p="5px 10px" text="X-0" onClick={()=>showResponseX(0)}/>
				<Button p="5px 10px" text="X-1" onClick={()=>showResponseX(1)}/>
				<Button p="5px 10px" text="X-2" onClick={()=>showResponseX(2)}/>
				<Button p="5px 10px" text="X-3" onClick={()=>showResponseX(3)}/>
				<Button p="5px 10px" text="X-4" onClick={()=>showResponseX(4)}/>
				<Button p="5px 10px" text="X-5" onClick={()=>showResponseX(5)}/>
				<Button p="5px 10px" text="X-6" onClick={()=>showResponseX(6)}/>
				{!InAndroid(0) && <CheckBox ml={5} text="On side" value={uiState.showLLMOutputOnSide} onChange={val=>RunInAction_Set(()=>uiState.showLLMOutputOnSide = val)}/>}
			</Row>
			<Text>Presets:</Text>
			<Row style={{flexWrap: "wrap", gap: 5}}>
				<Button p="0 5px" text="(manage)" onClick={()=>{
					const controller = ShowMessageBox({
						title: "LLM presets",
						okOnEnterKey: false,
						message: ()=><PresetsUI/>,
					});
				}}/>
				{uiState.llmPresets.map((preset, i)=>{
					return <Button key={i} p="0 5px" text={preset.name} style={{fontSize: 12}} onClick={()=>{
						let newInput = uiState.customLLMInput;
						// if input ends with non-whitespace, and preset starts with non-whitespace, add a space between them
						if (newInput.length && newInput[newInput.length - 1].match(/\S/) && preset.text[0].match(/\S/)) {
							newInput += " ";
						}
						newInput += preset.text;
						RunInAction_Set(()=>uiState.customLLMInput = newInput);
					}}/>;
				})}
			</Row>
			<Row>
				<Text>Input:</Text>
				<Row ml="auto">
					<Button mdIcon="refresh" title="Regenerate last response" enabled={storyComp != null} onClick={async()=>{
						if (storyComp == null) return;
						const secondLastMessageProto = storyComp.GetCurrentMessage(-1)!;
						const secondLastMessage = storyMessages.find(a=>a.id == secondLastMessageProto.uploadedId);
						Assert(secondLastMessage != null, "Could not find db-message corresponding to the 2nd-last entry in message-proto sequence.");
						await storyComp.LoadStoryForChain(storyComp.story!, storyMessages, secondLastMessage!);

						// we use db-msg's content rather than proto-msg's, since db-msg omits the "addendum" (letting us avoid a 2nd copy in new request-msg)
						const userMessageToResend = secondLastMessage.content;

						await storyComp.SetLatestStoryInput(storyComp.GetCurrentMessageIndex()! - 1, userMessageToResend, true, newMessage_firstSegmentIndex=>{
							if (storyComp.storyProtoMessages_textSegments_index != newMessage_firstSegmentIndex) return; // if user has already moved away from the current segment, don't voice it
							storyComp.SpeakCurrentText();
						}, uiState.customLLMInput_includeSystemPrompt, uiState.customLLMInput_includeAddendum);
					}}/>
					<CheckBox ml={5} text="Sys-prompt" value={uiState.customLLMInput_includeSystemPrompt} onChange={val=>{
						RunInAction_Set(()=>uiState.customLLMInput_includeSystemPrompt = val);
					}}/>
					<CheckBox ml={5} text="Addendum" value={uiState.customLLMInput_includeAddendum} onChange={val=>{
						RunInAction_Set(()=>uiState.customLLMInput_includeAddendum = val);
					}}/>
					<Button ml={5} text="Send" enabled={storyComp != null} onClick={async()=>{
						if (storyComp == null) return;
						const lastMessage = storyComp.GetCurrentMessage();
						const lastMessageIsUserInput = lastMessage?.role == "user";

						let currentMessageIndex = storyComp.GetCurrentMessageIndex();
						if (currentMessageIndex == null) return;

						if (lastMessageIsUserInput) {
							currentMessageIndex -= 1;
						}

						await storyComp.SetLatestStoryInput(currentMessageIndex, uiState.customLLMInput, true, newMessage_firstSegmentIndex=>{
							if (storyComp.storyProtoMessages_textSegments_index != newMessage_firstSegmentIndex) return; // if user has already moved away from the current segment, don't voice it
							storyComp.SpeakCurrentText();
						}, uiState.customLLMInput_includeSystemPrompt, uiState.customLLMInput_includeAddendum);

						RunInAction_Set(()=>uiState.customLLMInput = "");
					}}/>
				</Row>
			</Row>
			<TextArea instant style={{flex: 1}} value={uiState.customLLMInput} onChange={val=>RunInAction_Set(()=>uiState.customLLMInput = val)}/>
		</Column>
	);
});

const PresetsUI = observer_mgl(()=>{
	const uiState = store.main.engine.journey.llm;

	/*const Change = (..._)=>controller.UpdateUI();
	const RunInAction_Set_PlusChange = (classInstance: Object, setterFunc: ()=>any)=>{
		RunInAction_Set(classInstance, setterFunc);
		Change();
	};*/

	// when window-size changes, update canvas size to match it (needed, eg. if nav-button toolbar gets hidden just after overlay closes)
	const forceUpdate = useForceUpdate();
	UseWindowEventListener("resize", ()=>forceUpdate());

	return (
		<ScrollView style={{padding: `10px 0`, width: window.innerWidth - 50, height: window.innerHeight - 100}}>
			<Row>
				<Button text="Refresh standard presets" onClick={()=>{
					RunInAction_Set(()=>{
						const newPresets = uiState.llmPresets.slice();
						for (const [i, basePreset] of GetDefaultLLMPresets().entries()) {
							const presetAtSlot = newPresets[i] as LLMPreset|n;
							if (presetAtSlot?.name != basePreset.name) {
								newPresets.Insert(i, basePreset);
							}
						}
						uiState.llmPresets = newPresets;
					});
				}}/>
			</Row>
			{uiState.llmPresets.map((preset, i)=>{
				return <Row key={i}>
					<TextInput value={preset.name} onChange={val=>RunInAction_Set(()=>uiState.llmPresets[i].name = val)}/>
					<TextArea autoSize={true} value={preset.text} onChange={val=>RunInAction_Set(()=>uiState.llmPresets[i].text = val)}/>
					<Button mdIcon="delete" onClick={()=>{
						ShowMessageBox({
							title: "Delete preset", cancelButton: true,
							message: "Are you sure you want to delete this preset?",
							onOK: ()=>{
								RunInAction_Set(()=>uiState.llmPresets.Remove(preset));
							},
						});
					}}/>
				</Row>;
			})}
			<Button text="Add preset" onClick={()=>{
				RunInAction_Set(()=>uiState.llmPresets.push({name: "New preset", text: ""}));
			}}/>
		</ScrollView>
	)
});